// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1qVcF","checkboxCol":"Table_checkboxCol__bQ8mO","emailCol":"Table_emailCol__10UG_","actionCol":"Table_actionCol__2GdDj"};